import React from 'react';
import { string, number } from 'prop-types';
import PaymentsStatus from './PaymentsStatus';
import PaymentStatusIcon from './PaymentStatusIcon';
import DateTime from '../DateTime/DateTime';
import { formatToCurrency, currencyToSign } from '../../utils/utils';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  its: number.isRequired,
  uts: number.isRequired,
  purse: string.isRequired,
  purseTitle: string.isRequired,
  status: number.isRequired,
  total: number.isRequired,
  amount: number.isRequired,
  currency: string.isRequired,
  method: number.isRequired,
};

/**
 * Get purse title
 *
 * @param {string} mask Title mask
 * @param {string} purse Purse name
 * @return {string} Purse title
 */
// ПОСМОТРЕТЬ - МОЖЕТ МАСКА УЖЕ НЕ НУЖНА И ВЫПИЛИТЬ ЕЕ - пока возвращаю оригинал ПЮРС
const getPurseTitle = (mask = '%s', purse) => {
  // console.warn({mask, mL: mask.length, purse, RETURN: mask.replace('%s', purse)});

  // if(mask.length > 0) {
  //   return mask.replace('%s', purse);
  // }
  return purse;
};

/**
 * Get formatted payment amount
 *
 * @param {number} method Payment method
 * @param {number} amount Sum
 * @param {number} total Sum with commission
 * @param {string} currency Payment currency
 * @returns {JSX.Element} Formatted string
 */
const getPaymentAmount = (method, amount, total, currency) => {
  if (amount !== total) {
    return (
      <span className="payment-amount">
        {formatToCurrency(total)}&nbsp;{currencyToSign(currency)}{' '}
        <sup className='gray'>{formatToCurrency(amount)}&nbsp;{currencyToSign(currency)}</sup>
      </span>
    );
  } else {
    return (
      <span className="payment-amount">
        {formatToCurrency(total)}&nbsp;{currencyToSign(currency)}
      </span>
    );
  }
};

const PaymentOrdersListItem = ({
  its = 0,
  uts,
  purse,
  purseTitle,
  status,
  total,
  amount,
  currency,
  method,
  tableSettings,
  id,
  onCancelPaymentClick,
  cancelRequestStatus,
}) => {
  return tableSettings ? (
    <tr>
      {tableSettings.date && <td>
        <DateTime timestamp={its} />
      </td >}
      {tableSettings.total && <td>{getPaymentAmount(method, amount, total, currency)}</td>}
      {tableSettings.purse && <td>{getPurseTitle(purseTitle, purse)}</td>}
      {tableSettings.status && <td>
        <PaymentsStatus status={status} uts={uts} />
      </td>}
      {tableSettings.icon && <td className="text-right">
        <PaymentStatusIcon status={status} />
      </td>}
    </tr >
  ) : (
      <tr>
        <td>
          <DateTime timestamp={its} />
        </td >
        <td>{getPaymentAmount(method, amount, total, currency)}</td>
        <td>{getPurseTitle(purseTitle, purse)}</td>
        <td>
          <PaymentsStatus status={status} uts={uts} />
        </td>
        <td className="text-right">
          {status === 0 ? (
            <div className="d-flex justify-content-between align-items-center">
              <Button
                className="mr-2"
                size="sm"
                color="primary"
                onClick={() => onCancelPaymentClick(id)}
                disabled={cancelRequestStatus === 'pending'}
              >
                <FormattedMessage id="main.cancel" defaultMessage="Cancel" />
              </Button>
              <PaymentStatusIcon status={status} />
            </div>
          ) : (
            <PaymentStatusIcon status={status} />
          )}
        </td>
      </tr >
    )
};

PaymentOrdersListItem.propTypes = propTypes;

export default PaymentOrdersListItem;
